function mountBingResponse(res) {
  const bingAds = res?.results?.value || [];
  this.adContext.advertisers = bingAds.map((ad) => encodeURIComponent(ad?.displayUrl));
  const { dabuPlacementId } = this.dataset;
  const defaultConfig = { blocks: [{ placementId: dabuPlacementId }] };
  const bingOptions = this.win.amgAds.bingOptions || defaultConfig;
  bingOptions.blocks.forEach(({ placementId }, i) => {
    this.mountDabuResponse({ ...res, content: res.adContent[i] }, placementId);
    this.adPlacements[placementId].setMountedFlag();
  });
}

function generateTelemetryScripts(dabuRes) {
  const { clarityId, requestGUID, results } = dabuRes;
  const { instrumentation } = results;
  const clarityScript = this.doc.createElement('script');
  clarityScript.setAttribute('type', 'text/javascript');
  clarityScript.innerHTML = `(function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y); })(window,
    document, "clarity", "script", "${clarityId}");`;

  const telemetryJS = this.doc.createElement('script');
  telemetryJS.src = 'https://msadsscale.azureedge.net/bingads/telemetryJS.js';

  const initTelemetryJS = this.doc.createElement('script');
  initTelemetryJS.setAttribute('type', 'text/javascript');
  initTelemetryJS.setAttribute('charset', 'utf-8');
  const signalParameter = {
    requestGUID,
    clarityProjectId: clarityId,
    instrumentation,
  };

  initTelemetryJS.innerHTML = `
    var signalParameter = ${JSON.stringify(signalParameter)}
    initTelemetryJS(signalParameter);`;

  return {
    clarityScript,
    telemetryJS,
    initTelemetryJS,
  };
}

function mountTelemetryScript(dabuRes) {
  const { clarityScript, telemetryJS, initTelemetryJS } = this.generateTelemetryScripts(dabuRes);
  this.doc.head.appendChild(clarityScript);
  this.doc.head.appendChild(telemetryJS);

  telemetryJS.addEventListener('load', () => {
    this.doc.body.appendChild(initTelemetryJS);
    this.logger.debug('Mounting initTelemetryJS script to dom nodes', this.dataset.dabuPlacementId);
  });
}

async function getBingAds() {
  // we only use one placement for bing ads
  // so we can destructure the first item in the array here.
  try {
    const {
      o, rtb, q, maxSKSResults,
    } = this.pageParams;

    const { bingOptions = { slug: '', sksAsQuery: false } } = this.win.amgAds || {};

    const query = q || this.doc.title || bingOptions.slug;
    const dabuUrl = new URL(`${this.dabuUrl}/api/v2/ta/bing`);
    dabuUrl.searchParams.set('o', o);
    dabuUrl.searchParams.set('rtb', rtb);
    dabuUrl.searchParams.set('q', query);
    dabuUrl.searchParams.set('page', this.win.encodeURIComponent(this.win.location));
    dabuUrl.searchParams.set('pvid', this.pvId);
    dabuUrl.searchParams.set('sksAsQuery', bingOptions.sksAsQuery);

    if (maxSKSResults) {
      dabuUrl.searchParams.set('maxSKSResults', maxSKSResults);
    }

    // new features
    // url param bt overrides page-level config
    const template = this.pageParams.bt || bingOptions.template;
    if (bingOptions.template) dabuUrl.searchParams.set('template', template);
    if (Object.prototype.hasOwnProperty.call(bingOptions, 'repeatAds')) {
      if (bingOptions.repeatAds) dabuUrl.searchParams.set('repeatAds', 1);
    }

    // reverse the order of the ads so that the first ad will display at the bottom
    if (bingOptions.reverseAdOrder) dabuUrl.searchParams.set('reverseAdOrder', 1);

    if (bingOptions.blocks && Array.isArray(bingOptions.blocks)) {
      const c = bingOptions.blocks.map((b) => b.count).join(',');
      const ctaPosition = bingOptions.blocks.map((b) => b.ctaPosition).join(',');

      dabuUrl.searchParams.set('count', c);
      dabuUrl.searchParams.set('ctaPosition', ctaPosition);
    }
    const dabuRes = await this.callDabu(dabuUrl.toString());
    this.adContext.abTestBingTypeTag = dabuRes.bingTypeTag;
    this.adContext.bingAdUnitId = dabuRes.adUnitId;
    this.adContext.bingPropertyId = dabuRes.propertyId;
    this.mountTelemetryScript(dabuRes);
    this.mountBingResponse(dabuRes);
    this.firePageViewPixel();
  } catch (err) {
    // do nothing for bing search ads
    this.logger.error('error calling dabu', err);
  }
}

export {
  getBingAds, mountBingResponse, mountTelemetryScript, generateTelemetryScripts,
};
